import React from 'react';

export const OrderIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M51.2499 18.1943L29.9999 29.9999M29.9999 29.9999L8.74992 18.1943M29.9999 29.9999L30 53.75M35 52.2222L31.9426 53.9208C31.2336 54.3147 30.8791 54.5116 30.5036 54.5888C30.1714 54.6572 29.8287 54.6572 29.4964 54.5888C29.1209 54.5116 28.7664 54.3147 28.0574 53.9208L9.55743 43.643C8.80864 43.227 8.43421 43.019 8.16158 42.7231C7.92039 42.4614 7.73787 42.1512 7.62621 41.8133C7.5 41.4313 7.5 41.003 7.5 40.1464V19.8536C7.5 18.997 7.5 18.5687 7.62621 18.1867C7.73787 17.8487 7.92039 17.5385 8.16158 17.2768C8.43421 16.981 8.80862 16.773 9.55743 16.357L28.0574 6.07917C28.7664 5.68529 29.121 5.48833 29.4964 5.41112C29.8287 5.34278 30.1714 5.34278 30.5036 5.41112C30.8791 5.48833 31.2336 5.68528 31.9426 6.07917L50.4426 16.357C51.1914 16.773 51.5658 16.981 51.8384 17.2768C52.0796 17.5385 52.2621 17.8487 52.3738 18.1867C52.5 18.5687 52.5 18.997 52.5 19.8536L52.5 31.25M18.75 11.25L41.25 23.75M40 45L45 50L55 40"
        stroke="#222530"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
